<template>
  <v-container id="attendance-list">
    <h2>Gestão de Territórios</h2>

    <v-card class="mt-6 rounded-0">
      <v-bottom-navigation color="primary" class="w-100">
        <v-btn
          :to="'/gestao-territorios/' + tab.id"
          v-for="tab in tabs"
          :key="tab.id"
          class="flex-grow-1"
          style="max-width: none"
          @click="tabName = tab.id"
        >
          <span>{{ tab.name }}</span>
        </v-btn>
      </v-bottom-navigation>
    </v-card>
    <v-card v-for="tab in tabs" :key="tab.id" class="rounded-0 bg-light inside">
      <div v-if="tabName === tab.id" class="container-border">
        <component v-bind:is="dinamicyComponent(tab.component)"></component>
      </div>
    </v-card>
  </v-container>
</template>
<script>
import { mapActions } from "vuex";
import moment from "moment";

const tabsComponent = {
  Territorios: () => import("./territorios/List"),
  Categorias: () => import("./categorias/List"),
  Iniciativas: () => import("./iniciativas/List"),
  Responsaveis: () => import("./responsaveis/List"),
};

export default {
  data() {
    return {
      tabs: [
        { id: "territorios", name: "Territorios", component: "Territorios" },
        // { id: "vocacao", name: "Vocações", component: "Vocacao" },
        // { id: "potenciais", name: "Potenciais", component: "Potenciais" },
        {
          id: "categorias",
          name: "Categorias",
          component: "Categorias",
        },
        { id: "iniciativas", name: "Iniciativas", component: "Iniciativas" },
        { id: "responsaveis", name: "Responsáveis", component: "Responsaveis" },
      ],
      tabName: this.$route.params.tab,
    };
  },

  methods: {
    ...mapActions(["setLoading"]),
    dinamicyComponent(tab) {
      return tabsComponent[tab];
    },
  },
};
</script>
<style scoped lang="scss">
.v-btn--active {
  background: var(--corPrimaria) !important;
  color: #fff !important;
}

.container-border {
  border: 4px solid var(--corPrimaria);
}

.rela {
  margin-right: 10px;
  i {
    color: green !important;
  }
}
</style>
